module.exports = __webpack_public_path__ + "static/media/gender_neutral_toilet.75bd7be1.svg";